import { css } from '@repo/pandacss/styled-system/css';
import type { CSSProperties } from 'react';
import { renderStructuredContent } from '../../rendererContext';
import { ListProps } from './types';

export function List({ props: { ordered, children, rendererProps } }: ListProps) {
  const Component = ordered ? 'ol' : 'ul';
  return (
    <Component
      className={css({
        paddingLeft: '0',
        listStyleType: 'var(--sc-list-style-type)',
      })}
      style={{ '--sc-list-style-type': !ordered ? 'none' : 'disc' } as CSSProperties}
    >
      {renderStructuredContent(children, rendererProps)}
    </Component>
  );
}
